import { TypedUseSelectorHook, useDispatch, useSelector } from "react-redux";
import type { RootState, AppDispatch } from "./store";

export const useAppDispatch = () => useDispatch<AppDispatch>(); // Correctly typed
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
